import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const SuccessPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white shadow-2xl rounded-2xl p-8 text-center" data-testid="success-page">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-4">
            <CheckCircle className="w-16 h-16 text-green-600" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-4" data-testid="success-title">
          {t('thankYou')}
        </h1>
        
        <p className="text-slate-600 mb-8" data-testid="success-message">
          {t('willContact')}
        </p>
        
        <button
          onClick={() => navigate('/')}
          className="flex items-center justify-center gap-2 w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg shadow-lg hover:shadow-blue-500/30 transition-all"
          data-testid="button-back-to-careers"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{t('backToCareers')}</span>
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;